export default __webpack_public_path__ + "static/media/foto_app_prestadores.29c23850.png";